import { Tooltip } from "../components/Tooltip";
import { ArrowUpOnSquareIcon, ChevronLeftIcon, TrashIcon, XMarkIcon, } from "../icons/app";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
import { Button } from "./Button";
const barVariants = cva("s-flex s-flex-row s-items-center s-gap-3 s-px-4", {
    variants: {
        position: {
            top: "s-border-b",
            bottom: "s-border-t",
        },
        variant: {
            full: "s-fixed s-left-0 s-right-0 s-z-30 s-backdrop-blur s-border-border-dark/70 s-bg-background/80 dark:s-border-border-dark-night/70 dark:s-bg-background-night/80",
            default: "s-relative s-z-10 s-border-border s-bg-background dark:s-border-border-night dark:s-bg-background-night",
        },
        size: {
            sm: "s-h-14",
            md: "s-h-16",
        },
    },
    compoundVariants: [
        {
            position: "top",
            variant: "full",
            class: "s-top-0",
        },
        {
            position: "bottom",
            variant: "full",
            class: "s-bottom-0",
        },
    ],
    defaultVariants: {
        position: "top",
        variant: "full",
        size: "md",
    },
});
export function Bar({ title, description, tooltip, leftActions, centerActions, rightActions, className, position, variant, size, }) {
    const titleClasses = cn("s-text-foreground dark:s-text-foreground-night", "s-heading-base s-truncate");
    return (React.createElement("div", { className: cn(barVariants({ position, variant, size }), className) },
        leftActions && React.createElement("div", { className: "s-flex s-gap-1" }, leftActions),
        title && (React.createElement("div", { className: titleClasses }, tooltip ? (React.createElement(Tooltip, { tooltipTriggerAsChild: true, trigger: React.createElement(React.Fragment, null,
                typeof title === "string" ? React.createElement("span", null, title) : title,
                description), label: tooltip })) : (React.createElement(React.Fragment, null,
            typeof title === "string" ? React.createElement("span", null, title) : title,
            description)))),
        centerActions && React.createElement("div", { className: "s-flex s-gap-1" }, centerActions),
        React.createElement("div", { className: "s-flex-grow" }),
        rightActions && React.createElement("div", { className: "s-flex s-gap-1" }, rightActions)));
}
Bar.ButtonBar = function (props) {
    switch (props.variant) {
        case "back":
            return (React.createElement(Button, { size: "sm", icon: ChevronLeftIcon, variant: "ghost", tooltip: "Back", onClick: props.onBack }));
        case "close":
            return (React.createElement(Button, { size: "sm", icon: XMarkIcon, variant: "ghost", tooltip: "Close", onClick: props.onClose }));
        case "validate":
            return (React.createElement(React.Fragment, null,
                props.cancelButtonProps && React.createElement(Button, { ...props.cancelButtonProps }),
                props.saveButtonProps && React.createElement(Button, { ...props.saveButtonProps })));
        case "conversation":
            return (React.createElement(React.Fragment, null,
                React.createElement(Button, { size: "sm", icon: TrashIcon, tooltip: "Delete", variant: "ghost", onClick: props.onDelete }),
                React.createElement(Button, { size: "sm", label: "Share", icon: ArrowUpOnSquareIcon, variant: "ghost", onClick: props.onShare })));
        default:
            return null;
    }
};
export function BarHeader({ title, description, tooltip, leftActions, centerActions, rightActions, className, variant, size, }) {
    return (React.createElement(Bar, { position: "top", title: title, description: description, tooltip: tooltip, leftActions: leftActions, centerActions: centerActions, rightActions: rightActions, className: className, variant: variant, size: size }));
}
BarHeader.ButtonBar = Bar.ButtonBar;
export function BarFooter({ leftActions, rightActions, className, variant, size, }) {
    return (React.createElement(Bar, { position: "bottom", leftActions: leftActions, rightActions: rightActions, className: className, variant: variant, size: size }));
}
BarFooter.ButtonBar = Bar.ButtonBar;
//# sourceMappingURL=Bar.js.map